import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/trans"

export function recharge(rechargeDto) {
  return request({
    url: prefix + '/recharge',
    method: 'post',
    data: rechargeDto,
  })
}

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}
